import React, { useState, useEffect } from 'react'
import { TextField } from '@shopify/polaris';
import './style.css'
import actionTypes from '../../../store/actionTypes';
import { useDispatch } from 'react-redux';

const ReceiveStock = props => {

    const { receiveQty } = actionTypes

    const dispatch = useDispatch()

    const [Values, setValues] = useState({ qtyToShow: 0, bin: '', weight: '', dimensions: '' })

    useEffect(() => {
        dispatch({ type: receiveQty, payload: Values.qtyToShow + props.product.received })

    }, [Values])
    const handleChange = (key, value) => {
        setValues({ ...Values, [key]: value })
    }
    return (
        <table className="receiveTable">
            <tbody className="receiveTBody">
                <tr>
                    <td className="receiveTd">Supplier</td>
                    <th className="receiveTh">{props.product.vendor.name}</th>
                </tr>
                <tr>
                    <td className="receiveTd">Product ID</td>
                    <th className="receiveTh">{props.product.barcode}</th>
                </tr>
                <tr>
                    <td className="receiveTd">Name</td>
                    <th className="receiveTh"><span style={{ display: 'inline-block', maxWidth: '300px', whiteSpace: 'normal' }}>{props.product.description}</span></th>
                </tr>
                <tr>
                    <td className="receiveTd">Stock Ordered</td>
                    <th className="receiveTh">{props.product.qty}</th>
                </tr>
                <tr>
                    <td className="receiveTd">Stock Received</td>
                    <th className="receiveTh">{props.product.received}</th>
                </tr>
                <tr>
                    <td className="receiveTd">Qty. to show in</td>
                    <th className="receiveTh"><TextField type="number" value={Values.qtyToShow.toString()} onChange={value => handleChange('qtyToShow', Number(value))} max={props.product.qty} min={0} /></th>
                </tr>
                <tr>
                    <td className="receiveTd">Notes</td>
                    <th className="receiveTh"></th>
                </tr>
                <tr>
                    <td className="receiveTd">Destination Bin</td>
                    <th className="receiveTh"><TextField type="text" value={Values.bin} onChange={value => handleChange('bin', value)} /></th>
                </tr>
                <tr>
                    <td className="receiveTd">Weight</td>
                    <th className="receiveTh"><TextField type="text" value={Values.weight} onChange={value => handleChange('weight', value)} /></th>
                </tr>
                <tr>
                    <td className="receiveTd">Dimensions</td>
                    <th className="receiveTh"><TextField type="text" value={Values.dimensions} onChange={value => handleChange('dimensions', value)} /></th>
                </tr>
                <tr>
                    <td className="receiveTd" style={{ border: 'none' }}>Image</td>
                    <th className="receiveTh" style={{ border: 'none', textAlign: 'center' }}>
                        {
                            props.product.image ? <img src={props.product.image} alt="alt text" /> : 'Please take a picture of product'
                        }
                    </th>
                </tr>
            </tbody>
        </table>
    )
}

export default ReceiveStock
